import Vue from "vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueCryptojs from "vue-cryptojs";
import store from "@/state/store";
import axios from "axios";

const toastOpt = {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
};
Vue.use(Toast, toastOpt);
Vue.use(VueCryptojs);

Vue.prototype.formatDate = function (dt) {
  if (dt == null) return "";
  let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(dt);
  let mo = new Intl.DateTimeFormat("en", { month: "long" }).format(dt);
  let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(dt);
  return `${mo} ${da}, ${ye}`;
};
Vue.prototype.formatDateShort = function (dt) {
  if (dt == null) return "";
  let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(dt);
  let mo = new Intl.DateTimeFormat("en", { month: "short" }).format(dt);
  let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(dt);
  return `${mo} ${da}, ${ye}`;
};
Vue.prototype.formatDateWithTime = function (dt) {
  if (dt == null) return "";
  let time = new Intl.DateTimeFormat("en", {
    dateStyle: "long",
    timeStyle: "short",
  }).format(dt);
  return time;
};
Vue.prototype.formatDateShortWTime = function (dt) {
  if (dt == null) return "";
  const optionsDate = { year: "numeric", month: "short", day: "2-digit" };
  const optionsTime = { hour: "numeric", minute: "2-digit", hour12: true };

  const datePart = new Intl.DateTimeFormat("en", optionsDate).format(dt);
  const timePart = new Intl.DateTimeFormat("en", optionsTime).format(dt);
  return `${datePart} at ${timePart}`;
};
Vue.prototype.getDate = function (data) {
  let thisDate = new Date(data);
  var year = thisDate.getFullYear();
  var month = thisDate.getMonth() + 1;
  var day = thisDate.getDate();
  var hour = thisDate.getHours();
  var min = thisDate.getMinutes();
  var second = thisDate.getSeconds();
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${String(hour).padStart(2, "0")}:${String(min).padStart(2, "0")}:${String(second).padStart(2, "0")}`;
};
Vue.prototype.getExactAmt = function (amount) {
  return amount.toString().replace(/,/g, "");
};
Vue.prototype.diffDate = (date) => {
  const date1 = new Date(date);
  const date2 = new Date();
  const diffTime = Math.abs(date2 - date1);
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  const diffSecond = diffTime / 1000;
  const diffMin = diffTime / (1000 * 60);
  const diffHour = diffTime / (1000 * 60 * 60);
  if (diffDays >= 1) {
    if (diffDays > 365) {
      return `${Math.floor(diffDays / 365)} years ago`;
    }
    if (diffDays > 30) {
      let month = Math.trunc(diffDays / 30);
      return `${month} ${month > 1 ? "months" : "month"}  ago`;
    }
    return `${Math.trunc(diffDays)} days ago`;
  } else {
    if (diffHour >= 1) {
      return `${Math.trunc(diffHour)} hours ago`;
    }
    if (diffMin >= 1) {
      return `${Math.trunc(diffMin)} min ago`;
    }
    if (diffSecond >= 0) {
      return `${Math.trunc(diffSecond)} seconds ago`;
    }
    return "0 second ago";
  }
};
Vue.prototype.pageLoader = (display) => {
  if (display) {
    document.getElementById("full-page-loader").classList.remove("d-none");
  } else {
    document.getElementById("full-page-loader").classList.add("d-none");
  }
};
Vue.prototype.scrollToTop = () => {
  window.scrollTo(0, 0);
};
Vue.prototype.showToast = (message, type) => {
  Vue.$toast[`${type}`](message, {
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
  });
};
Vue.prototype.showPermanentToast = (message, type) => {
  Vue.$toast[`${type}`](message, {
    position: "top-right",
    timeout: 20000,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
  });
};
Vue.prototype.numberWithCommas = (x) => {
  let number = roundNumber(x, 2);
  let splitted = number.toString().split(".");
  if (splitted.length > 1) {
    return splitted[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + splitted[1];
  } else {
    return splitted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};
Vue.prototype.decryptToken = (encryptedText) => {
  var rawData = Vue.CryptoJS.enc.Base64.parse(encryptedText);
  var key = Vue.CryptoJS.enc.Latin1.parse(store.state.data.decipherCode);
  var plaintextData = Vue.CryptoJS.AES.decrypt({ ciphertext: rawData }, key, {
    iv: Vue.CryptoJS.enc.Latin1.parse(""),
  });
  var plaintext = plaintextData.toString(Vue.CryptoJS.enc.Latin1);
  return plaintext;
};
Vue.prototype.formatCurrency = (amount) => {
  return Intl.NumberFormat("ja-JP", {
    currency: "PHP",
    style: "currency",
    roundingMode: "trunc",
  }).format(parseFloat(amount).toFixed(2));
};
function roundNumber(num, scale) {
  if (Math.round(num) != num) {
    if (Math.pow(0.1, scale) > num) {
      return 0;
    }
    var sign = Math.sign(num);
    var arr = ("" + Math.abs(num)).split(".");
    if (arr.length > 1) {
      if (arr[1].length > scale) {
        var integ = +arr[0] * Math.pow(10, scale);
        var dec = integ + (+arr[1].slice(0, scale) + Math.pow(10, scale));
        var proc = +arr[1].slice(scale, scale + 1);
        if (proc >= 5) {
          dec = dec + 1;
        }
        dec = (sign * (dec - Math.pow(10, scale))) / Math.pow(10, scale);
        return dec;
      }
    }
  }
  return num;
}
Vue.prototype.bytesToSize = (bytes) => {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

Vue.prototype.encryptUrl = (data) => {
  let encrypted = btoa(data);
  let encryptions = [
    {
      key: '=',
      value: 'eQs'
    },
    {
      key: '/',
      value: 'bckS'
    }
  ]
  encryptions.forEach(encryption => {
    encrypted = encrypted.replaceAll(encryption.key, encryption.value)
  })
  return encrypted;
};
Vue.prototype.decryptUrl = (data) => {
  let encryptions = [
    {
      key: 'eQs',
      value: '='
    },
    {
      key: 'bckS',
      value: '/'
    }
  ]
  encryptions.forEach(encryption => {
    data = data.replaceAll(encryption.key, encryption.value)
  })
  return atob(data);
};

// custom repeating functions

Vue.prototype.updateApiResourceImg = async (cropData, apiResource) => {
  let success = false;
  let data = "";
  if (apiResource.thumbnailUrl !== "") {
    await store.dispatch("filemanager/DeleteFileByReference", {
      referenceId: apiResource.id,
      type: "Resource Item Profile",
    });
  }
  let fullData = {
    id: apiResource.id,
    type: "Resource Item Profile",
    folder: "Procurement",
    file: cropData.fullImg,
    description: "Original Image",
  };
  let fullUrl = "";
  let cropUrl = "";
  await store
    .dispatch("filemanager/UploadFile", fullData)
    .then((res) => {
      if (res.data.error) {
        return this.showToast(res.data.errorMessage, "error");
      }
      fullUrl = res.data.fileName;
    })
    .catch((err) => { });
  let croppedData = {
    id: apiResource.id,
    type: "Resource Item Profile",
    folder: "Procurement",
    file: cropData.cropImg,
    description: cropData.cropData,
  };
  await store
    .dispatch("filemanager/UploadFile", croppedData)
    .then((res) => {
      if (res.data.error) {
        return this.showToast(res.data.errorMessage, "error");
      }
      cropUrl = res.data.fileName;
    })
    .catch((err) => { });
  if (fullUrl === "" && cropUrl === "") {
    return this.showToast("Something went wrong!", "error");
  }
  let updateItem = { ...apiResource };
  delete updateItem.image;
  delete updateItem.thumbnail;
  let updateData = {
    image: fullUrl,
    thumbnail: cropUrl,
    ...updateItem,
  };
  await store
    .dispatch("apiresource/UpdatePPMPItem", updateData)
    .then((res) => {
      if (res.data.error) {
        data = res.data.errorMessage;
        return (success = false);
      }
      success = true;
    })
    .catch((err) => {
      data = "Something went wrong!";
      success = false;
    });
  if (success) {
    return { success: true, data: updateData };
  } else {
    return { success: false, data: data };
  }
};

Vue.prototype.formatDateCustom = (data) => {
  return new Date(data).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

Vue.prototype.formatDateToISO = (data) => {
  const nDate = new Date(new Date(data).getTime() - new Date(data).getTimezoneOffset() * 60 * 1000);
  return nDate.toISOString();
};
Vue.directive('click-outside', {
  priority: 700,
  bind() {
    let self = this;
    this.event = function (event) {
      self.vm.$emit(self.expression, event);
    };
    this.el.addEventListener('click', this.stopProp);
    document.body.addEventListener('click', this.event);
  },
  unbind() {
    this.el.removeEventListener('click', this.stopProp);
    document.body.removeEventListener('click', this.event);
  },
  stopProp(event) { event.stopPropagation() }
})

Vue.prototype.attachedDUNotifications = () => {
  let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
  if (!dashboardData) return;
  let dashboardMenu = document.getElementById('dashboard-menu');
  let elementTop = document.getElementById('delivery-unit');
  let badgeTopId = document.getElementById('badge-top');
  let technicalId = document.getElementById('badge-technical');
  let bacId = document.getElementById('badge-bac');
  let modifId = document.getElementById('badge-modif');
  let requisitionId = document.getElementById('badge-requisition');
  let procurementId = document.getElementById('badge-procurement');
  let contractId = document.getElementById('badge-contract');
  let supId = document.getElementById('badge-sup');
  let procId = document.getElementById('badge-proc');
  let dtsId = document.getElementById('badge-dts');
  let dtsOfficeId = document.getElementById('badge-returnedtrack');
  let dtsIncomingId = document.getElementById('badge-incomingtrack');
  let actualBadge = document.getElementById('badge-actual');
  let badgeItemReq = document.getElementById('badge-item-list');
  let badgePlanning = document.getElementById('badge-planning');
  let badgePlanningOPCR = document.getElementById('badge-planning-opcr');
  if (badgeItemReq) {
    badgeItemReq.remove();
  }
  if (badgeTopId) {
    badgeTopId.remove();
  }
  if (technicalId) {
    technicalId.remove();
  }
  if (bacId) {
    bacId.remove();
  }
  if (modifId) {
    modifId.remove();
  }
  if (requisitionId) {
    requisitionId.remove();
  }
  if (procurementId) {
    procurementId.remove();
  }
  if (contractId) {
    contractId.remove();
  }
  if (supId) {
    supId.remove();
  }
  if (procId) {
    procId.remove();
  }
  if (dtsId) {
    dtsId.remove();
  }
  if (dtsOfficeId) {
    dtsOfficeId.remove();
  }
  if (dtsIncomingId) {
    dtsIncomingId.remove();
  }
  if (actualBadge) {
    actualBadge.remove();
  }
  if (badgePlanning) {
    badgePlanning.remove();
  }
  if (badgePlanningOPCR) {
    badgePlanningOPCR.remove();
  }
  let procurementElement = document.getElementById('procurement');
  if (procurementElement && (dashboardData.pendingContractExtensions > 0)) {
    const badgeTop = document.createElement('small');
    procurementElement.className = 'position-relative';
    badgeTop.className = 'position-absolute badge bg-danger font-size-10 ms-1 right-10';
    badgeTop.innerHTML = dashboardData.pendingContractExtensions;
    badgeTop.setAttribute('id', 'badge-procurement')
    procurementElement.appendChild(badgeTop);
  }
  let contractElement = document.getElementById('menu-incoming-deliveries');
  if (contractElement && dashboardData.pendingContractExtensions > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.pendingContractExtensions;
    badgeBottom.setAttribute('id', 'badge-contract');
    contractElement.appendChild(badgeBottom);
  }
  if (dashboardMenu && (dashboardData.needBacApproval > 0 || dashboardData.itemRequest > 0)) {
    const badgeDash = document.createElement('small');
    dashboardMenu.className = 'position-relative';
    badgeDash.className = 'position-absolute badge bg-danger font-size-10 ms-1 right-10';
    badgeDash.innerHTML = dashboardData.needBacApproval + dashboardData.itemRequest;
    badgeDash.setAttribute('id', 'badge-dashboard')
    dashboardMenu.appendChild(badgeDash);
  }
  if (elementTop && (dashboardData.returnedItemRequests > 0 || dashboardData.needRequisitionAssign > 0 || dashboardData.draftRequisitions > 0 || dashboardData.totalReturnedRealignment > 0 || dashboardData.returnedTracks > 0 || dashboardData.incomingTracks > 0 || (dashboardData.targetIds && dashboardData.targetIds.length) || dashboardData.planningOpcrNotifications > 0)) {
    const badgeTop = document.createElement('small');
    elementTop.className = 'position-relative';
    badgeTop.className = 'position-absolute badge bg-danger font-size-10 ms-1 right-10';
    badgeTop.innerHTML = dashboardData.returnedItemRequests + dashboardData.needRequisitionAssign + dashboardData.draftRequisitions + dashboardData.totalReturnedRealignment + dashboardData.returnedTracks + dashboardData.incomingTracks + dashboardData.itemRequest + dashboardData.targetIds.length + dashboardData.planningOpcrNotifications;
    badgeTop.setAttribute('id', 'badge-top')
    elementTop.appendChild(badgeTop);
  }
  let actualElement = document.getElementById('menu-actual');
  if (actualElement && dashboardData.targetIds && dashboardData.targetIds.length) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.targetIds.length;
    badgeBottom.setAttribute('id', 'badge-actual');
    actualElement.appendChild(badgeBottom);
  }
  let planningElement = document.getElementById('menu-planning');
  if (planningElement && dashboardData.planningOpcrNotifications > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.planningOpcrNotifications;
    badgeBottom.setAttribute('id', 'badge-planning');
    planningElement.appendChild(badgeBottom);
  }
  let planningOPCR = document.getElementById('menu-planning-opcr');
  if (planningOPCR && dashboardData.planningOpcrNotifications > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.planningOpcrNotifications;
    badgeBottom.setAttribute('id', 'badge-planning-opcr');
    planningOPCR.appendChild(badgeBottom);
  }
  let technicalElement = document.getElementById('menu-technical-review');
  if (technicalElement && dashboardData.itemRequest > 0) {
    // if(technicalElement && (dashboardData.needTechnicalReview > 0  || dashboardData.itemRequest > 0)){
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.itemRequest;
    // badgeBottom.innerHTML = dashboardData.needTechnicalReview + dashboardData.itemRequest;
    badgeBottom.setAttribute('id', 'badge-technical');
    technicalElement.appendChild(badgeBottom);
  }
  let procElement = document.getElementById('procurement-menu');
  if (procElement && (dashboardData.returnedItemRequests > 0)) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.returnedItemRequests;
    badgeBottom.setAttribute('id', 'badge-proc');
    procElement.appendChild(badgeBottom);
  }
  let bacElement = document.getElementById('menu-bac-review');
  if (bacElement && dashboardData.needBacApproval > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.needBacApproval;
    badgeBottom.setAttribute('id', 'badge-bac');
    bacElement.appendChild(badgeBottom);
  }
  let itemListElement = document.getElementById('menu-item-list');
  if (itemListElement && dashboardData.returnedItemRequests > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.returnedItemRequests;
    badgeBottom.setAttribute('id', 'badge-item-list');
    itemListElement.appendChild(badgeBottom);
  }

  let modifElement = document.getElementById('menu-modification');
  if (modifElement && dashboardData.totalReturnedRealignment > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.totalReturnedRealignment;
    badgeBottom.setAttribute('id', 'badge-modif');
    modifElement.appendChild(badgeBottom);
  }
  let supElement = document.getElementById('supply-menu');
  if (supElement && (dashboardData.needRequisitionAssign > 0 || dashboardData.draftRequisitions > 0)) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.needRequisitionAssign + dashboardData.draftRequisitions;
    badgeBottom.setAttribute('id', 'badge-sup');
    supElement.appendChild(badgeBottom);
  }
  let requisitionElement = document.getElementById('menu-property-requisition');
  if (requisitionElement && (dashboardData.needRequisitionAssign > 0 || dashboardData.draftRequisitions > 0)) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.needRequisitionAssign + dashboardData.draftRequisitions;
    badgeBottom.setAttribute('id', 'badge-requisition');
    requisitionElement.appendChild(badgeBottom);
  }
  let dtsElement = document.getElementById('dts-office-menu');
  if (dtsElement && (dashboardData.incomingTracks > 0 || dashboardData.returnedTracks > 0)) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.incomingTracks + dashboardData.returnedTracks;
    badgeBottom.setAttribute('id', 'badge-dts');
    dtsElement.appendChild(badgeBottom);
  }
  let officeTrackElement = document.getElementById('du-office-tracks');
  if (officeTrackElement && dashboardData.returnedTracks > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.returnedTracks;
    badgeBottom.setAttribute('id', 'badge-returnedtrack');
    officeTrackElement.appendChild(badgeBottom);
  }
  let incomingTrackElement = document.getElementById('du-incoming-tracks');
  if (incomingTrackElement && dashboardData.incomingTracks > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.incomingTracks;
    badgeBottom.setAttribute('id', 'badge-incomingtrack');
    incomingTrackElement.appendChild(badgeBottom);
  }
};

Vue.prototype.attachedDepartmentNotifications = () => {
  let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
  if (!dashboardData) return;
  let elementTop = document.getElementById('department-menu');
  let badgeTopId = document.getElementById('badge-department-top');
  let dtsDeptId = document.getElementById('badge-dts-dept');
  let dtsDeptOfficeId = document.getElementById('badge-returnedtrack-dept');
  let dtsDeptIncomingId = document.getElementById('badge-incomingtrack-dept');
  if (badgeTopId) {
    badgeTopId.remove();
  }
  if (dtsDeptId) {
    dtsDeptId.remove();
  }
  if (dtsDeptOfficeId) {
    dtsDeptOfficeId.remove();
  }
  if (dtsDeptIncomingId) {
    dtsDeptIncomingId.remove();
  }
  if (elementTop && (dashboardData.returnedDepartmentTracks > 0 || dashboardData.incomingDepartmentTracks > 0)) {
    const badgeTop = document.createElement('small');
    elementTop.className = 'position-relative';
    badgeTop.className = 'position-absolute badge bg-danger font-size-10 ms-1 right-10';
    badgeTop.innerHTML = dashboardData.returnedDepartmentTracks + dashboardData.incomingDepartmentTracks;
    badgeTop.setAttribute('id', 'badge-department-top')
    elementTop.appendChild(badgeTop);
  }
  let dtsDepartmentElement = document.getElementById('dts-department-menu');
  if (dtsDepartmentElement && (dashboardData.incomingDepartmentTracks > 0 || dashboardData.returnedDepartmentTracks > 0)) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.incomingDepartmentTracks + dashboardData.returnedDepartmentTracks;
    badgeBottom.setAttribute('id', 'badge-dts-dept');
    dtsDepartmentElement.appendChild(badgeBottom);
  }
  let officeTrackDepartmentElement = document.getElementById('department-office-tracks');
  if (officeTrackDepartmentElement && dashboardData.returnedDepartmentTracks > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.returnedDepartmentTracks;
    badgeBottom.setAttribute('id', 'badge-returnedtrack-dept');
    officeTrackDepartmentElement.appendChild(badgeBottom);
  }
  let incomingTrackDepartmentElement = document.getElementById('department-incoming-tracks');
  if (incomingTrackDepartmentElement && dashboardData.incomingDepartmentTracks > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.incomingDepartmentTracks;
    badgeBottom.setAttribute('id', 'badge-incomingtrack-dept');
    incomingTrackDepartmentElement.appendChild(badgeBottom);
  }
};

Vue.prototype.attachedFinanceNotifications = () => {
  let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
  if (!dashboardData) return;
  let elementTop = document.getElementById('finance-menu');
  let badgeTopId = document.getElementById('badge-finance-top');
  if (badgeTopId) {
    badgeTopId.remove();
  }
  let modifId = document.getElementById('badge-finance-modif');
  if (modifId) {
    modifId.remove();
  }
  if (elementTop && (dashboardData.pendingRealignmentRequest > 0)) {
    const badgeTop = document.createElement('small');
    elementTop.className = 'position-relative';
    badgeTop.className = 'position-absolute badge bg-danger font-size-10 ms-1 right-10';
    badgeTop.innerHTML = dashboardData.pendingRealignmentRequest;
    badgeTop.setAttribute('id', 'badge-finance-top')
    elementTop.appendChild(badgeTop);
  }
  let modifElement = document.getElementById('menu-modification-finance');
  if (modifElement && dashboardData.pendingRealignmentRequest > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.pendingRealignmentRequest;
    badgeBottom.setAttribute('id', 'badge-finance-modif');
    modifElement.appendChild(badgeBottom);
  }
};

Vue.prototype.changeMenuOPCRWFP = () => {
  let campus = store.state.data.selectedCampus;
  if (campus && campus.isExternal) {
    if (document.getElementById('menu-actual-opcr')) document.getElementById('menu-actual-opcr').innerText = 'WFP';
    if (document.getElementById('menu-actual-target')) document.getElementById('menu-actual-target').innerText = 'Deliverables';
    if (document.getElementById('menu-planning-opcr')) document.getElementById('menu-planning-opcr').innerText = 'WFP';
    if (document.getElementById('menu-planning-target')) document.getElementById('menu-planning-target').innerText = 'Deliverables';
  } else {
    if (document.getElementById('menu-actual-opcr')) document.getElementById('menu-actual-opcr').innerText = 'OPCR'
    if (document.getElementById('menu-actual-target')) {
      document.getElementById('menu-actual-target').innerText = 'Targets & Accomplishments';
      let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
      if (!dashboardData) return;
      let badgeTarget = document.getElementById('badge-target');
      if (badgeTarget) {
        badgeTarget.remove();
      }
      let targetElement = document.getElementById('menu-actual-target');
      if (targetElement && dashboardData.targetIds && dashboardData.targetIds.length) {
        const badgeBottom = document.createElement('span');
        badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
        badgeBottom.innerHTML = dashboardData.targetIds.length;
        badgeBottom.setAttribute('id', 'badge-target');
        targetElement.appendChild(badgeBottom);
      }
    }
    if (document.getElementById('menu-planning-opcr')) document.getElementById('menu-planning-opcr').innerText = 'OPCR';
    if (document.getElementById('menu-planning-target')) document.getElementById('menu-planning-target').innerText = 'Targets';
  }
}
Vue.prototype.changeMenuPMEPMT = () => {
  let dashboardData = JSON.parse(localStorage.getItem('dashboardData'));
  if (!dashboardData) return;

  if (document.getElementById('menu-actual-review-pme')) {
    document.getElementById('menu-actual-review-pme').innerText = 'PMT Secretariat Review';
    let badgeActualPME = document.getElementById('badge-actual-review-pme');
    if (badgeActualPME) {
      badgeActualPME.remove();
    }
    let actualPMEElement = document.getElementById('menu-actual-review-pme');
    if (actualPMEElement && (dashboardData.pmeReview > 0)) {
      const badgeBottom = document.createElement('span');
      badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
      badgeBottom.innerHTML = dashboardData.pmeReview;
      badgeBottom.setAttribute('id', 'badge-actual-review-pme');
      actualPMEElement.appendChild(badgeBottom);
    }
  }

  if (document.getElementById('menu-actual-review-pmt')) {
    document.getElementById('menu-actual-review-pmt').innerText = 'PMT Rating';
    let badgeActualPMT = document.getElementById('badge-actual-review-pmt');
    if (badgeActualPMT) {
      badgeActualPMT.remove();
    }
    let actualPMTElement = document.getElementById('menu-actual-review-pmt');
    if (actualPMTElement && (dashboardData.pmtRating > 0)) {
      const badgeBottom = document.createElement('span');
      badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
      badgeBottom.innerHTML = dashboardData.pmtRating;
      badgeBottom.setAttribute('id', 'badge-actual-review-pmt');
      actualPMTElement.appendChild(badgeBottom);
    }
  }

  let badgeActualReview = document.getElementById('badge-actual-review');
  if (badgeActualReview) {
    badgeActualReview.remove();
  }
  let actualReviewElement = document.getElementById('menu-actual-review');
  if (actualReviewElement && dashboardData.pmeReview > 0 || dashboardData.pmtRating > 0) {
    const badgeBottom = document.createElement('span');
    badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
    badgeBottom.innerHTML = dashboardData.pmeReview + dashboardData.pmtRating;
    badgeBottom.setAttribute('id', 'badge-actual-review');
    actualReviewElement.appendChild(badgeBottom);
  }

  let badgePerformanceManagement = document.getElementById('badge-performance-management');
  let performanceManagementElement = document.getElementById('performance-management-menu');
  if (performanceManagementElement && dashboardData.pmeReview > 0 || dashboardData.pmtRating > 0) {
    if (badgePerformanceManagement) {
      badgePerformanceManagement.innerHTML = dashboardData.pmeReview + dashboardData.pmtRating;
    } else {
      const badgeBottom = document.createElement('span');
      badgeBottom.className = 'badge bg-danger font-size-10 ms-1';
      badgeBottom.innerHTML = dashboardData.pmeReview + dashboardData.pmtRating;
      badgeBottom.setAttribute('id', 'badge-performance-management');
      performanceManagementElement.appendChild(badgeBottom);
    }
  } else {
    if (badgePerformanceManagement) {
      badgePerformanceManagement.remove();
    }
  }
}
Vue.prototype.wait = (delay, ...args) => new Promise((resolve) => setTimeout(resolve, delay, ...args));

Vue.prototype.taxIds = [1381, 2379, 2380, 2381, 2382];
Vue.prototype.bankIds = [2421, 2422, 2423, 2424, 2425, 2426];
Vue.prototype.formatNumber = (number) => {
  if (Number.isInteger(number)) {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } else {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
}
Vue.prototype.deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
}

Vue.prototype.addDays = (date, days) => {
  var result = new Date(date);
  var newResult = result.setDate(result.getDate() + parseFloat(days));
  return newResult;
}
Vue.prototype.ExcelDateToJSDate = (serial) => {
  var utc_days = Math.floor(serial - 25569);
  var utc_value = utc_days * 86400;
  var date_info = new Date(utc_value * 1000);

  var fractional_day = serial - Math.floor(serial) + 0.0000001;

  var total_seconds = Math.floor(86400 * fractional_day);

  var seconds = total_seconds % 60;

  total_seconds -= seconds;

  var hours = Math.floor(total_seconds / (60 * 60));
  var minutes = Math.floor(total_seconds / 60) % 60;

  return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
}
Vue.prototype.readFile = async (id) => {
  document.getElementById("full-page-loader").classList.remove("d-none");
  try {
    let res = await axios.get(`api/FileManager/ReadFile/${id}`, { withCredentials: true, responseType: 'blob' })
    let contentType = res.headers["content-type"];
    if (contentType.includes("json")) {
      return false;
    }
    let cd = res.headers["content-disposition"];
    let cdArr = cd.split(";");
    let filename = cdArr[1].trim().replace('filename=', '');
    var url = URL.createObjectURL(res.data);
    if (contentType.includes("pdf") || contentType.includes("image")) {
      window.open(url, '_blank');
    } else {
      var a = document.createElement("a");
      a.setAttribute("download", `${filename}`);
      a.setAttribute("href", url);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    document.getElementById("full-page-loader").classList.add("d-none");
    return true;
  } catch (e) {
    document.getElementById("full-page-loader").classList.add("d-none");
    return false;
  }
}
Vue.prototype.moveNumbersToEnd = (str) => {
  const firstCharIsNumber = /^\d/.test(str);
  const numbers = firstCharIsNumber
    ? str.slice(1).match(/\d+/g)?.join('') || ''
    : str.match(/\d+/g)?.join('') || '';
  const stringWithoutNumbers = firstCharIsNumber
    ? str[0] + str.slice(1).replace(/\d+/g, '')
    : str.replace(/\d+/g, '');
  return stringWithoutNumbers + numbers;
}
Vue.prototype.GLOBAL_FROM_SCHOOL = window.IS_SCHOOL || false;